module.exports = __webpack_public_path__ + "img/home_carousel_image_3.821d4a9b.png";